export default "__VITE_ASSET__ac3e438f__"